import guid from '@/lib/guid';
import ApiService from '@/services/api.service';




export class FreeDomain {
  constructor({id = null, _id = null, name = ``, description = ``, type = null, userId = null, status = null, openId = null, openCode = null, username = null, content = null, foreignId = null} = {}) {
    //
    this.id = id;
    if(!this.id) {
      this.id = guid.createId('project');
    }
    this._id = _id;
    this.name = name;
    this.description = description;
    this.type = type;
    this.userId = userId;
    this.username = username;
    this.openId = openId;
    this.openCode = openCode;
    this.status = status;
    this.foreignId = foreignId;
    this.content = content;

    this.hydrateContentToObject();


  }
  hydrateContentToObject() {
    try {
      if (typeof this.content === 'string' || this.content instanceof String) {
        this.content = JSON.parse(this.content);
      }
    } catch(err) {
      console.log("err", err);
    }

  }
  hydrateForApi() {
    let payload = {};
    payload.id = this.id;
    payload._id = this._id;
    payload.name = this.name;
    payload.description = this.description;
    payload.type = this.type;
    payload.userId = this.userId;
    payload.username = this.username;
    payload.openId = this.openId;
    payload.openCode = this.openCode;
    payload.status = this.status;
    payload.foreignKey = this.foreignKey;
    payload.content = this.content;

    if (typeof payload.content === 'string' || payload.content instanceof String) {

    } else {
      try {
        payload.content = JSON.stringify(payload.content);
      } catch(err) {

      }

    }
    return payload;
  }
}

export async function upsertContent(table, freeDomain) {

  freeDomain.hydrateContentToObject();
  let payload = freeDomain.hydrateForApi();
  // console.log("payload", payload);
  const response = await ApiService.post('/legalworkflow/' + table, payload);

  return new FreeDomain(response.data);
}


export async function requestSignature(table, freeDomain) {

  freeDomain.hydrateContentToObject();
  let payload = freeDomain.hydrateForApi();
  // console.log("payload", payload);
  const response = await ApiService.post('/legalworkflow/request-signature/' + table, payload);

  return new FreeDomain(response.data);
}

export async function getContent(table, id) {
  const response = await ApiService.query('/legalworkflow/' + table + "/" + id, {});
  return new FreeDomain(response.data);
}

export async function getSignatureContent(table, id) {
  const response = await ApiService.query('/legalworkflow/public/signature/' + table + "/" + id, {});
  return new FreeDomain(response.data);
}



export async function getChildrenContent(table, id) {
  const response = await ApiService.query('/legalworkflow/children/' + table + "/" + id, {});
  let domains = [];
  for(let i = 0; i < response.data.length; i++) {
    domains.push(new FreeDomain(response.data[i]));
  }
  return domains;
}

export function createContent(data) {
  if(typeof data == "undefined") {
    data = {};
  }
  return new FreeDomain(data);
}
